module.exports = __webpack_public_path__ + "img/img1.3cdd202c.svg";